import cloneDeepWith from "lodash.clonedeepwith";
import rootLogger from './log';
import {getCmInPx} from './utils';

const log = rootLogger.getLogger('popup');

const popups = [];

/**
 * @callback PopupWindowCallback
 * @param {Window} window
 * @return Promise<string>
 */

/**
 * @param {Element} element
 * @returns {string}
 */
function generatePopupWindowFeatures(element) {
    let returnString = 'popup';
    if (element?.dataset.popupWidthCm) {
        returnString += `,width=${getCmInPx(parseFloat(element.dataset.popupWidthCm))}`;
    }
    if (element?.dataset.popupHeightCm) {
        returnString += `,height=${getCmInPx(parseFloat(element.dataset.popupHeightCm))}`;
    }
    return returnString;
}

/**
 * @param {Element} element
 * @param {PopupWindowCallback} popupWindowCallback
 */
export default function(element, popupWindowCallback)
{
    if (window.initRemoveOldPreviews === undefined) {
        window.addEventListener('beforeunload', () => {
            // NOTE: we need this clone otherwise we aren't able to close all popups. Probably because we lose our references?
            cloneDeepWith(popups).forEach(popup => {
                popup.close();
            });
        });
        window.initRemoveOldPreviews = true;
    }
    element.addEventListener('click', () => {
        let createdWindow = window.open('', element.id, generatePopupWindowFeatures(element));
        popups.push(createdWindow);
        let linkElement = document.querySelector('[rel="stylesheet"]').cloneNode(true);
        createdWindow.document.querySelector('head').appendChild(linkElement);
        createdWindow.document.querySelector('body').innerHTML = '<div class="card p-5"><div class="col text-center"><span class="spinner-border"></span></div></div>';
        createdWindow.addEventListener('beforeunload', () => {
            let index = popups.indexOf(createdWindow);
            if (index !== -1) {
                popups.splice(index, 1);
            }
        });
        new Promise((resolve, reject) => {
            try {
                const html = popupWindowCallback(createdWindow);
                resolve(html);
            } catch (e) {
                reject(e);
            }
        }).then(html => {
            createdWindow.document.querySelector('body').innerHTML = html;
        }).catch(exception => {
            createdWindow.close();
            log.error(exception);
            throw exception;
        });
    });
}
